import React from 'react';
import { Calendar as CalendarIcon, MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Calendar = () => {
  const { t } = useLanguage();

  const events = [
    {
      name: 'Carnaval de Venise',
      type: 'culturel',
      date: 'Février 2026',
      location: 'Venise, Italie'
    },
    {
      name: 'Salon de l\'Horlogerie',
      type: 'business',
      date: 'Avril 2026',
      location: 'Genève, Suisse'
    },
    {
      name: 'Soirée Prestige au Festival de Cannes',
      type: 'gala',
      date: 'Mai 2026',
      location: 'Cannes, France'
    },
    {
      name: 'Week-end d\'exception au Grand Prix de Monaco',
      type: 'sport',
      date: 'Mai 2026',
      location: 'Monaco'
    },
    {
      name: 'Salon Art à Basel',
      type: 'culturel',
      date: 'Juin 2026',
      location: 'Basel, Suisse'
    },
    {
      name: 'Top Marques Monaco',
      type: 'business',
      date: 'Juin 2026',
      location: 'Monaco'
    },
    {
      name: 'Le Polo de Chantilly et le Rallye D\'Aumale',
      type: 'sport',
      date: 'Juillet 2026',
      location: 'Chantilly, France'
    },
    {
      name: 'Soirées Palace Royal Monceau Paris',
      type: 'gala',
      date: 'Juillet-Août 2026',
      location: 'Paris, France'
    },
    {
      name: 'Week-end Golf et Palace en Sardaigne',
      type: 'sport',
      date: 'Septembre 2026',
      location: 'Sardaigne, Italie'
    },
    {
      name: 'Cannes Yachting Festival',
      type: 'business',
      date: 'Septembre 2026',
      location: 'Cannes, France'
    },
    {
      name: 'Monaco Yacht Show',
      type: 'business',
      date: 'Septembre 2026',
      location: 'Monaco'
    },
    {
      name: 'Soirée privée Hôtel Particulier Paris',
      type: 'gala',
      date: 'Septembre 2026',
      location: 'Paris, France'
    },
    {
      name: 'LBY de Varsovie',
      type: 'business',
      date: 'Novembre 2026',
      location: 'Varsovie, Pologne'
    },
    {
      name: 'Master Expo Rai Amsterdam',
      type: 'business',
      date: 'Décembre 2026',
      location: 'Amsterdam, Pays-Bas'
    },
    {
      name: 'Polo on Ice St. Moritz',
      type: 'sport',
      date: 'Janvier 2027',
      location: 'St. Moritz, Suisse'
    }
  ];

  const getTypeBadgeColor = (type) => {
    const colors = {
      culturel: '#8b7355',
      business: '#2c5f7d',
      gala: '#8b4f6d',
      sport: '#5d7d4f'
    };
    return colors[type] || '#666666';
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h1 className="hero-large" style={{ marginBottom: '16px' }}>
            Calendrier des Manifestations 2026
          </h1>
          <p className="body-large" style={{
            color: 'var(--text-secondary)',
            maxWidth: '900px',
            margin: '0 auto',
            lineHeight: 1.8
          }}>
            Chaque 2 mois, recevez un récapitulatif de toutes les manifestations à venir avec tous les détails nécessaires. Profitez des avantages exclusifs que votre carte vous offre. Réservez facilement votre présence en ligne et bénéficiez d'entrées privilégiées.
          </p>
          <p className="body-small" style={{
            color: 'var(--text-light)',
            marginTop: '16px',
            fontStyle: 'italic'
          }}>
            *Calendrier non contractuel
          </p>
        </div>
      </section>

      {/* Events Grid */}
      <section className="section-padding">
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
            gap: '32px'
          }}>
            {events.map((event, index) => (
              <div
                key={index}
                className="hover-lift"
                style={{
                  padding: '32px',
                  background: 'var(--bg-secondary)',
                  border: '1px solid var(--border-light)',
                  position: 'relative'
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  padding: '4px 12px',
                  background: getTypeBadgeColor(event.type),
                  color: 'var(--bg-primary)',
                  fontSize: '11px',
                  fontWeight: 600,
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}>
                  {event.type}
                </div>
                <h3 className="heading-2" style={{
                  marginBottom: '16px',
                  paddingRight: '80px'
                }}>
                  {event.name}
                </h3>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '8px'
                }}>
                  <CalendarIcon size={16} color="var(--text-secondary)" />
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {event.date}
                  </span>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px'
                }}>
                  <MapPin size={16} color="var(--text-secondary)" />
                  <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                    {event.location}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Calendar;